const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class ShockTroops extends Tactic {
    constructor() {
        super(
            Age.Age2,
            TacticNames.ShockTroops,
            [1, 3, 0],
            "11(6)",
            {}
        )
    }
}

module.exports = ShockTroops;